// The Slovenian texts are the prototype's own, word for word where a screen matches.
export default {
    offer: {
        save_hint: 'Si apre la finestra di stampa — per il PDF scegliete come destinazione «Salva come PDF».',
        invalid_title: 'Offerta non disponibile',
        invalid_text: "Il link all'offerta è scaduto o è stato sostituito. Contattate l'hotel.",
        eyebrow: 'Offerta per il gruppo',
        eyebrow_reservation: 'La vostra offerta',
        nights: 'pernottamenti',
        financials: 'Offerta',
        col_item: 'Voce',
        col_quantity: 'Quantità',
        col_price: 'Prezzo/unità',
        col_discount: 'Sconto',
        col_vat: 'IVA',
        col_amount: 'Importo',
        total_net: 'Totale senza IVA',
        vat_at: 'IVA {rate} %',
        remaining: 'Da pagare',
        rooms: 'Alloggio',
        per_night: 'notte',
        up_to: 'fino a {count} persone in camera',
        total: 'Totale',
        paid: 'Già pagato',
        services: 'Servizi della struttura',
        included: 'a disposizione degli ospiti',
        valid_until: "L'offerta è valida fino al {date}.",
        contact: 'Domande e conferma',
        print: 'Stampa',
        save: 'Salva PDF',
        confirm: 'Conferma offerta',
        confirmed_at: "Offerta confermata il {date}. Grazie — l'hotel è stato avvisato.",
        units: { hour: 'ora', day: 'giorno', night: 'notte', person: 'persona', use: 'utilizzo', item: 'pezzo', treatment: 'trattamento' },
    },
    rooming: {
        pick: 'Scegli …',
        invalid_title: 'Link non valido',
        invalid_text: "Il link per l'inserimento degli ospiti è scaduto o è stato sostituito. Contattate l'hotel.",
        intro: "Inserite gli ospiti del vostro gruppo. L'hotel esaminerà l'elenco e assegnerà le camere — l'inserimento qui non costituisce ancora una prenotazione.",
        add_title: 'Aggiungi ospite',
        first_name: 'Nome',
        last_name: 'Cognome',
        email: 'E-mail',
        phone: 'Telefono',
        notes: 'Note',
        add: 'Aggiungi',
        added: "L'ospite è stato aggiunto all'elenco.",
        failed: "Non è stato possibile salvare l'inserimento.",
        entered: 'Ospiti inseriti ({count})',
        none_yet: 'Nessun ospite inserito.',
        booking_title: 'Inserimento compagni di viaggio',
        rooms_title: 'Camere',
        rooms_count: '{count} camere',
        filled_of: 'Inseriti {filled} di {capacity}',
        pick_room_first: 'Selezionate prima una camera qui sopra.',
        adding_to: 'Aggiunta a: {room}',
        unassigned: 'Non assegnato',
        date_of_birth: 'Data di nascita',
        nationality: 'Cittadinanza',
        nationality_hint: 'es. SI',
        document_type: 'Tipo di documento',
        document_type_hint: 'es. passaporto',
        document_number: 'Numero documento',
        confirmed: 'Confermato',
        booked_note: "Gli ospiti già assegnati sono confermati dall'hotel; comunicate eventuali modifiche alla reception.",
        register_hint: "Data di nascita, cittadinanza e documento sono necessari per la registrazione dell'ospite prevista dalla legge. I dati vengono verificati alla reception all'arrivo.",
    },
    keys: {
        title: 'Chiavi',
        your_room: 'LA VOSTRA CAMERA',
        your_pin: 'IL VOSTRO CODICE PIN',
        pin_text: "Con il codice PIN aprite tutte le vostre porte, oppure potete usare l'apertura a distanza qui sotto.",
        your_keys: 'LE VOSTRE CHIAVI',
        door_room: 'Camera',
        room_on_arrival: "assegnata all'arrivo",
        hold: 'Tenete premuto per sbloccare',
        unlocked: 'Sbloccato',
        preview_note: "L'apertura a distanza funzionerà quando la struttura collegherà le serrature al sistema — fino ad allora è un'anteprima.",
        demo_done: 'Anteprima — le serrature non sono ancora collegate.',
    },
    nav: {
        menu: 'Menu',
        roomservice_hint: 'Cibo e bevande direttamente in camera',
        roomservice: 'Servizio in camera',
        keys: 'Chiavi',
        short_keys: 'Chiavi',
        overview: 'Panoramica',
        checkin: 'Check-in',
        stay: 'Il mio soggiorno',
        arrival: 'Arrivo',
        services: 'Servizi',
        payments: 'Pagamenti e conti',
        short_overview: 'Home',
        short_checkin: 'Check-in',
        short_arrival: 'Arrivo',
        short_services: 'Servizi',
        short_payments: 'Conto',
        house: 'La struttura',
    },
    general: {
        back: 'Indietro',
        cancel: 'Annulla',
        close: 'Chiudi',
        save_failed: 'Salvataggio non riuscito. Riprovate.',
    },
    theme: {
        title: 'Tema chiaro/scuro',
        to_dark: 'Attiva il tema scuro',
        to_light: 'Attiva il tema chiaro',
    },
    overview: {
        eyebrow: 'IL VOSTRO PROSSIMO SOGGIORNO',
        language: 'Lingua',
        welcome: 'Benvenuti a',
        welcome_named: 'Benvenuti, {names}',
        and: 'e',
        subtitle: "Qui gestite tutto prima dell'arrivo e durante il soggiorno.",
        arrival: 'ARRIVO',
        departure: 'PARTENZA',
        reservation: 'PRENOTAZIONE',
        ready: "Pronti per l'arrivo",
        almost: "Pronti per l'arrivo",
        all_done: 'Tutto pronto',
        one_more_step: 'Ancora un passaggio',
        steps_left_two: 'Ancora 2 passaggi',
        steps_left_few: 'Ancora {n} passaggi',
        step_profile: 'Dati personali',
        step_document: 'Documento',
        step_payment: 'Pagamento',
        finish_checkin: 'Completa il check-in',
        card_checkin: 'Check-in online',
        card_checkin_text: 'Completate i dati degli ospiti e velocizzate le operazioni alla reception.',
        card_checkin_go: 'Continua il check-in',
        card_stay: 'Il mio soggiorno',
        card_stay_text: "Camera, orario di arrivo, richieste particolari e istruzioni per l'arrivo.",
        card_stay_go: 'Vedi la prenotazione',
        card_services: "Servizi dell'hotel",
        card_services_text: 'Massaggio, sauna, cena o noleggio di biciclette.',
        card_services_go: 'Esplora i servizi',
        card_room_service: 'Servizio in camera',
        card_room_service_text: 'Cibo e bevande dalla cucina dell\'hotel, direttamente in camera.',
        card_room_service_go: 'Vai al menù',
        card_money: 'Costi e pagamenti',
        card_money_go: 'Apri conto e pagamento',
        card_keys_title: 'Chiavi',
        card_keys_none: "La chiave e il codice PIN vi attendono dopo il check-in e l'assegnazione della camera.",
        card_keys_get: 'Ottieni la chiave',
        card_keys_go: 'Tutte le chiavi e il PIN',
        card_arrival: 'Arrivo e posizione',
        card_arrival_text: "Indirizzo, navigazione e foto dell'ingresso, del parcheggio e del garage.",
        card_arrival_go: "Vedi le istruzioni per l'arrivo",
        card_house: 'La struttura e i dintorni',
        card_house_text: 'Wi-Fi, orari, lettera di benvenuto, listino prezzi e cosa succede in città.',
        card_house_go: 'Apri le informazioni della struttura',
        partly_paid: 'Parzialmente pagato',
        charges: 'Costi del soggiorno',
        parking_charges: 'Costi di parcheggio',
        paid: 'Pagato',
        balance: 'Saldo residuo',
    },
    checkin: {
        pick: 'Scegli …',
        title: 'Check-in online',
        subtitle: "I dati vengono trasmessi in modo sicuro direttamente all'hotel.",
        step_guests: 'Ospiti',
        step_documents: 'Documenti',
        step_payment: 'Pagamento',
        step_confirm: 'Conferma',
        guests_title: 'Ospiti sulla prenotazione',
        unnamed: 'Ospite senza nome',
        document_read: 'Documento letto · dati completi',
        document_missing: 'Documento mancante',
        document_entered: "Dati inseriti · la reception li verifica all'arrivo",
        done_badge: 'Completato',
        add_document: 'Inserisci i dati',
        add_companion: 'Aggiungi accompagnatore',
        first_name: 'Nome',
        last_name: 'Cognome',
        companion_hint: 'Aggiungete una persona che soggiorna con voi. Il documento si inserisce nel passaggio successivo, come per voi stessi.',
        companion_room: 'Camera',
        companion_save: 'Aggiungi persona',
        companion_saved: 'Persona aggiunta — inserite ora il suo documento.',
        companion_incomplete: 'Inserite nome e cognome (e selezionate la camera).',
        companion_failed: 'Non è stato possibile aggiungere la persona — la camera potrebbe essere già piena. Rivolgetevi alla reception.',
        wishes_title: 'Arrivo e richieste',
        expected_arrival: 'Arrivo previsto',
        phone: 'Numero di cellulare',
        phone_placeholder: '+386 41 234 567',
        wishes: 'Richieste particolari',
        wishes_placeholder: 'Camera silenziosa, piano alto',
        plate: 'Targa',
        plate_hint: "Se parcheggerete l'auto nel parcheggio o nel garage.",

        // Marketing consent (docs/MARKETING.md §13). Never pre-ticked.
        consent_title:  'Offerte via e-mail',
        consent_label:  "Desidero ricevere le offerte e le novità dell'hotel via e-mail.",
        consent_hint:   'Può revocare il consenso in qualsiasi momento — anche con un clic in fondo a ogni messaggio. I messaggi sulla sua prenotazione arrivano comunque.',
        consent_failed: 'Non è stato possibile salvare il consenso.',
        save_for_later: 'Salva per dopo',
        continue_payment: 'Continua al pagamento',
        saved: 'Il check-in è stato salvato.',
        doc_title: 'Aggiungi documento',
        doc_type: 'Tipo di documento',
        doc_number: 'Numero documento',
        doc_nationality: 'Cittadinanza',
        doc_nationality_hint: 'Codice del Paese di due lettere, es. SI, DE, IT.',
        doc_birth: 'Data di nascita',
        doc_save: 'Salva i dati',
        doc_saved: 'Il documento è stato salvato.',
        doc_incomplete: "Compilate tutti i campi — senza di essi non è possibile registrare l'ospite.",
        doc_hint: "Leggete il documento con l'app Imprion ID Scan oppure inserite i dati manualmente. La foto non viene salvata.",
        doc_manual: 'Inserimento manuale',
        doc_idscan: 'Apri ID Scan',
        doc_coming: 'La lettura del documento tramite il portale arriverà presto — fino ad allora il documento viene letto alla reception.',
    },
    stay: {
        requests_title: 'LE VOSTRE RICHIESTE',
        request_extension: 'Prolungamento di {nights} notti',
        request_late_checkout: 'Check-out posticipato',
        request_pending: 'in attesa della reception',
        request_confirmed: 'confermato',
        request_declined: 'purtroppo non possibile',
        title: 'Il mio soggiorno',
        room: 'Camera',
        room_assigned_on_arrival: "La camera verrà assegnata all'arrivo",
        occupancy: '{adults} adulti · {children} bambini',
        expected: 'previsto {hour}',
        late_checkout: 'Richiedi partenza posticipata',
        room_released_title: 'Uscita dalla camera',
        room_released_text: 'Il check-out è stato effettuato, ma per noi la camera risulta ancora occupata. Appena ci comunicate di averla lasciata, possiamo prepararla per il prossimo ospite.',
        room_released: 'Ho lasciato la camera',
        room_released_sent: 'Grazie - abbiamo comunicato che la camera è libera.',
        extension_check: 'Verifica la possibilità di prolungare',
        extension_title: 'Prolungamento del soggiorno',
        extension_hint: 'Verificate se le notti dopo la vostra partenza sono ancora libere. La richiesta va alla reception, che conferma il prolungamento — nulla viene prenotato automaticamente.',
        extension_same_room: 'Libero — potete restare nella stessa camera',
        extension_other_room: 'Libero — con cambio camera',
        extension_full: 'Purtroppo non ci sono camere libere per queste notti.',
        extension_price: 'stima {amount}/notte secondo il vostro pacchetto',
        extension_request: 'Richiedi +{nights}',
        extension_sent: 'La richiesta di prolungamento è stata inviata alla reception — vi risponderanno.',
        late_checkout_sent: 'La richiesta di partenza posticipata è stata inviata.',
        call: 'Chiama',
        status_booked: 'Prenotato',
        status_confirmed: 'Confermato',
        status_checked_in: 'Check-in effettuato',
        status_checked_out: 'Check-out effettuato',
    },
    parking: {
        maps_card: 'Posizione e navigazione in Google Maps',
        card_title: 'Parcheggio',
        card_title_both: 'Parcheggio e garage',
        card_text: "Inserite la targa per l'apertura automatica della sbarra all'arrivo e durante il soggiorno.",
        add: 'Aggiungi targa',
        change: 'Modifica o aggiungi accesso',
        active_badge: 'Sbarra attiva',
        active_until: "L'ingresso automatico è attivo fino al {date}.",
        title: 'Ingresso automatico in garage',
        hint: 'La telecamera alla sbarra riconoscerà la targa durante il soggiorno e aprirà automaticamente la sbarra.',
        maps: 'Apri in Google Maps',
        copy: 'Copia indirizzo',
        copied: 'Indirizzo copiato.',
        plate: 'Targa del veicolo',
        placeholder: 'es. MB AB-123',
        validity: "Validità dell'accesso",
        validity_range: 'dal {from} al {to}',
        activate: 'Conferma e attiva',
        activated: "La targa {plate} è attivata per l'ingresso automatico.",
        check_plate: 'Verificate la targa.',
        extra_cars: 'Veicoli aggiuntivi',
        add_car: "Aggiungi un'altra auto",
        remove_car: 'Rimuovi',
        removed: 'La targa è stata rimossa; la sbarra non si aprirà più per essa.',
        removed_booking_kept: 'La targa è stata rimossa. La prenotazione del parcheggio non può più essere annullata tramite il portale — la gestisce la reception.',
        first_car_price: "Posto auto per il soggiorno: {amount}. L'importo viene aggiunto al conto del soggiorno.",
        included_note: 'Il parcheggio è incluso nel prezzo del pernottamento.',
        remove_car_done: 'La prenotazione per {plate} è stata annullata e detratta dal conto del soggiorno.',
        add_car_price: "Posto auto per il resto del soggiorno: {amount}. L'importo viene aggiunto al conto del soggiorno.",
        add_car_book: 'Prenota e aggiungi al conto',
        add_car_done: 'Il posto auto per {plate} è prenotato e aggiunto al conto del soggiorno.',
    },
    arrival: {
        title: 'Arrivo in hotel',
        navigate: 'Navigazione',
        back_to_stay: 'Torna al soggiorno',
        entrance_title: 'Ingresso principale',
        entrance_text: 'Breve sosta per i bagagli e accesso senza scalini.',
        parking_title: 'Parcheggio esterno',
        parking_text: 'Ingresso con la vostra targa.',
        garage_title: 'Ingresso del garage',
        garage_text: 'La sbarra si apre automaticamente quando la telecamera riconosce la targa del veicolo.',
    },
    services: {
        room_service_link: 'Servizio in camera',
        title: 'Servizi ed esperienze',
        subtitle: 'I servizi possono essere aggiunti direttamente al conto del soggiorno.',
        loading: "Caricamento dell'offerta …",
        booked_title: 'GIÀ PRENOTATO',
        edit: 'Modifica',
        edit_close: 'Chiudi modifica',
        edit_save: 'Conferma modifica',
        edit_hint: 'Scegliete i nuovi giorni; periodo continuo senza interruzioni.',
        edit_gap: 'Scegliete giorni consecutivi — per due periodi separati effettuate due prenotazioni.',
        edited: 'La prenotazione è stata spostata.',
        edit_failed: "Non è stato possibile effettuare la modifica — i giorni potrebbero essere già occupati. Controllate l'elenco.",
        desk_only_now: 'Modifica o annullamento ora solo tramite la reception.',
        withdraw: 'Annulla',
        withdrawn: "La prenotazione è stata annullata. Se era già stata addebitata, l'importo è stato stornato.",
        withdraw_failed: "Non è stato possibile effettuare l'annullamento — rivolgetevi alla reception.",
        policy_until_start: "Annullamento gratuito tramite il portale fino all'inizio.",
        policy_hours: "Annullamento gratuito tramite il portale fino a {hours} h prima dell'inizio.",
        policy_desk_only: 'Annullamento solo tramite la reception.',
        quantity: 'Quanti',
        per_days: '/ {days} giorni',
        days_count: '{days} giorni',
        full_days: 'Occupato: {days}',
        plate_nth: 'Targa del veicolo {number}',
        per_day: '/ giorno',
        stay_total: '{amount} per {nights} giorni',
        book: 'Prenota per il soggiorno',
        full: 'Per il vostro soggiorno non ci sono più posti liberi.',
        none: 'La struttura al momento non offre servizi prenotabili tramite il portale. Per gli appuntamenti (massaggio, cena) rivolgetevi alla reception.',
        confirm_text: "Prenotazione per l'intero soggiorno, {from}–{to}. L'importo {amount} viene aggiunto al vostro conto dell'hotel.",
        confirm: 'Conferma prenotazione',
        cancel: 'Annulla',
        needs_plate: 'Inserite la targa del veicolo.',
        booked: 'Prenotato. Il servizio è sul conto del soggiorno.',
        book_failed: 'La prenotazione non è riuscita — riprovate o rivolgetevi alla reception.',
        status_booked: 'prenotato',
        status_in_progress: 'in corso',
        status_completed: 'completato',
        status_cancelled: 'annullato',
        status_no_show: 'non utilizzato',
    },
    room_service: {
        categories: 'Menù',
        my_orders: 'I vostri ordini',
        basket_open: 'Carrello',
        basket_title: 'Il vostro ordine',
        when: 'Orario di consegna',
        when_asap: 'Il prima possibile',
        when_today: 'Oggi alle {time}',
        when_tomorrow: 'Domani alle {time}',
        closed_now_later: 'La cucina ora non serve — potete ordinare per più tardi.',
        ordered_at: 'ordinato {when}',
        deliver_for: 'consegna {when}',
        ordered_for: 'Ordine ricevuto per le {time} — {amount} sul conto della camera.',
        title: 'Servizio in camera',
        subtitle: 'Ordinate dalla cucina dell\'hotel — l\'importo va sul conto della camera.',
        loading: 'Caricamento del menù …',
        load_failed: 'Non è stato possibile caricare il menù. Controllate la connessione e riprovate.',
        retry: 'Riprova',
        to_room: 'CONSEGNA IN CAMERA {room}',
        hours: 'Cucina oggi: {hours}',
        shut_today: 'oggi chiusa',
        closed_now: 'La cucina al momento non accetta ordini. Riprovate durante l\'orario di apertura.',
        less: 'Togli uno',
        more: 'Aggiungi uno',
        empty_menu: 'L\'hotel non ha ancora aggiunto nulla al menù.',
        basket: 'IL VOSTRO ORDINE',
        basket_empty: 'Con + aggiungete cibo o bevande.',
        total: 'Totale',
        note: 'Messaggio per la cucina',
        note_placeholder: 'es. senza cipolla, due coperti',
        terms: 'Alla conferma la cucina riceve l\'ordine e l\'importo va sul conto della camera, da pagare al check-out.',
        order: 'Ordina · {amount}',
        sending: 'Invio …',
        clear: 'Svuota',
        orders: 'I VOSTRI ORDINI',
        ordered: 'Ordine ricevuto — {amount} sul conto della camera.',
        retry_hint: 'Nessuna risposta. Premete di nuovo Ordina — l\'ordine non verrà duplicato.',
        failed: 'La cucina non ha accettato l\'ordine. Controllatelo e riprovate o chiamate la reception.',
        not_offered: 'L\'hotel non offre il servizio in camera tramite questo portale. Per ordinare chiamate la reception.',
        not_in_house: 'Il servizio in camera è disponibile dopo il check-in.',
        menu_unreadable: 'Al momento non è possibile leggere il menù. Riprovate tra qualche minuto o chiamate la reception.',
    },
    stay_services: {
        per_appointment: '/ appuntamento',
        opens_at_checkin: 'Gli appuntamenti in hotel (massaggio, sauna …) e i servizi dei partner nelle vicinanze si possono prenotare dopo il check-in.',
        room: 'Per quale camera',
        appointments: 'APPUNTAMENTI IN HOTEL',
        loading_times: 'Verifico gli orari liberi …',
        times_failed: 'Non è stato possibile leggere gli orari liberi. Riprovate.',
        departed: 'Il vostro soggiorno è terminato — non è più possibile prenotare nuovi appuntamenti.',
        no_times: 'Non ci sono orari liberi prima della vostra partenza.',
        departure_day: 'Il giorno della partenza sono offerti solo appuntamenti che terminano entro le {time}.',
        book: 'Prenota · {amount}',
        on_bill: 'sul conto della camera',
        booked: 'Appuntamento prenotato — {amount} sul conto della camera.',
        book_failed: 'Non è stato possibile prenotare l\'appuntamento — forse è appena stato preso. Scegliete di nuovo.',
        nearby: 'SERVIZI NELLE VICINANZE',
        minutes: '{minutes} min',
        partner_down: 'Il partner al momento non risponde. Riprovate tra qualche minuto o chiedete alla reception.',
        no_times_day: 'Il partner non ha orari liberi in questo giorno.',
        partner_terms: 'Prenotiamo l\'orario presso {partner}. Il pagamento avviene come concordato con l\'hotel — sul conto della camera o presso il partner.',
        nearby_done: 'Prenotato — vi aspettano.',
        taken: 'Questo orario è appena stato preso presso il partner. Sceglietene un altro.',
        nearby_booked: 'LE VOSTRE PRENOTAZIONI PRESSO I PARTNER',
        cancel: 'Annulla',
        cancel_confirm: 'Conferma l\'annullamento',
        cancel_changed: 'Il costo dell\'annullamento è cambiato nel frattempo.',
        cancel_unknown: 'All\'annullamento possono applicarsi le condizioni di {partner} — chiedete il costo alla reception o confermate l\'annullamento.',
        cancel_late: 'Annullamento tardivo: il partner addebita {amount} sulla vostra camera.',
        cancel_late_free: 'Il termine per l\'annullamento gratuito è scaduto, ma il partner non addebita nulla per questo servizio.',
        cancel_free: 'L\'annullamento è gratuito fino al {deadline}.',
        cancel_gone: 'Questa prenotazione non può più essere annullata qui. Chiedete alla reception.',
        cancelled: 'La prenotazione è annullata.',
        cancelled_fee: 'La prenotazione è annullata. Il partner addebiterà {amount} sul conto della camera.',
        cancel_failed: 'Non è stato possibile annullare. Riprovate o chiedete alla reception.',
    },
    order_pin: {
        title: 'PIN per gli ordini',
        hint: 'L\'hotel chiede il vostro PIN prima di un ordine o di una prenotazione. Lo avete ricevuto al check-in dalla reception o via e-mail.',
        label: 'PIN',
        confirm: 'Conferma',
        wrong: 'Il PIN non è corretto. Riprovate.',
        locked: 'Troppi tentativi errati. Riprovate tra qualche minuto o chiedete alla reception.',
    },
    payment_done: {
        paid_title: 'Pagamento riuscito',
        paid_text: 'Grazie! Il pagamento è stato effettuato — la reception lo vedrà registrato in pochi secondi.',
        cancelled_title: 'Pagamento non effettuato',
        cancelled_text: 'Non è stato addebitato nulla. Per un nuovo tentativo rivolgetevi alla reception.',
    },
    payments: {
        details_open: 'Vedi ordine',
        details_total: 'Totale',
        details_tax: 'di cui IVA {rate} %: {amount}',
        title: 'Pagamenti e conti',
        reservation: 'Prenotazione {number}',
        open_badge: 'Aperto',
        folio_title: 'Conto del soggiorno',
        due: 'Da pagare',
        pay_starting: 'Apertura del pagamento …',
        pay_failed: 'Non è stato possibile avviare il pagamento — riprovate o rivolgetevi alla reception.',
        paid_message: 'Il pagamento è riuscito. Grazie!',
        method_cash: 'contanti',
        method_card: 'carta',
        method_transfer: 'bonifico',
        method_voucher: 'buono',
        method_prepayment: 'acconto',
        method_ota_virtual_card: 'carta virtuale',
        processing_title: 'Pagamento in elaborazione',
        processing_text: 'Attendiamo la conferma del fornitore di pagamento. Di solito richiede pochi secondi — la pagina vi avviserà quando il pagamento sarà registrato.',
        processing_timeout: 'Ancora nessuna conferma. Se il pagamento è stato effettuato apparirà a breve tra le voci — altrimenti rivolgetevi alla reception.',
        overpaid_message: "L'importo pagato è superiore a quello dovuto — la reception salderà la differenza come credito.",
        cancelled_message: 'Il pagamento è stato annullato.',
        settled_badge: 'Saldato',
        stripe_note: "La carta si inserisce sulla pagina sicura di Stripe; l'hotel non vede né conserva i dati della carta. Ambiente di prova.",
        pay_now: 'Paga ora',
        proforma: 'Scarica proforma',
        proforma_failed: 'Non è stato possibile preparare la proforma — riprovate.',
        invoices: 'Fatture',
        invoices_text: 'La fattura definitiva sarà disponibile al termine del soggiorno.',
        documents: 'Documenti',
        no_invoice_yet: 'La fattura definitiva non è ancora stata emessa.',
        secure_title: 'Pagamento sicuro',
        secure_text: "I dati della carta non vengono conservati né dall'hotel né da Imprion.",
        pay_title: 'Pagamento {amount}',
        simulated: 'Pagamento simulato — la carta non verrà addebitata.',
        simulated_done: 'Questa era una simulazione — il pagamento online arriverà in una delle prossime versioni.',
        cardholder: 'Titolare della carta',
        card_number: 'Numero della carta',
        expiry_cvc: 'Scadenza / CVC',
        pay_secure: 'Paga in sicurezza',
    },
    studio: {
        button: 'Personalizza il portale',
        title: "Personalizzazione del portale dell'hotel",
        hint: 'Anteprima per la configurazione della singola struttura. Imprion Guest resta indicato come fornitore del portale.',
        primary: 'Colore principale',
        accent: "Colore d'accento",
        compact: 'elementi più squadrati',
        preview_only: "Solo anteprima — l'aspetto della struttura viene salvato dalla reception.",
    },
    license: {
        eyebrow: 'Check-in online',
        title: 'Questo servizio non è attivo',
        lead: 'Questo hotel non ha attivato il check-in online, quindi questo portale non può essere aperto. La sua prenotazione non è in alcun modo modificata.',
        another_link: 'Se nel frattempo ha ricevuto un altro link, lo apra semplicemente: questa pagina verrà ricaricata.',
        contact: 'Per qualsiasi cosa riguardi il suo soggiorno si rivolga alla reception dell’hotel: sarà lieta di aiutarla.',
    },
    memory: {
        eyebrow: 'Un ricordo del soggiorno',
        thanks: 'Grazie della visita',
        lead: 'È stato un piacere ospitarvi. Qui resta un breve ricordo del vostro soggiorno.',
        stayed: 'Soggiorno',
        room: 'Camera',
        used: 'Cosa avete usato',
        nights: 'Notti',
        nights_one: '{n} notte',
        nights_two: '{n} notti',
        nights_few: '{n} notti',
        nights_many: '{n} notti',
        guests: 'Ospiti',
        guests_one: '{n} ospite',
        guests_two: '{n} ospiti',
        guests_few: '{n} ospiti',
        guests_many: '{n} ospiti',
        book_again: 'Prenota di nuovo',
        invoice: 'Inviatemi la fattura via e-mail',
        invoice_sending: 'Invio in corso…',
        invoice_sent: 'La fattura è stata inviata all\'indirizzo e-mail che ci avete indicato.',
        invoice_failed: 'Non è stato possibile inviare la fattura ora. Riprovate più tardi o scrivete all\'hotel.',
        privacy: 'Questa pagina resta aperta e non contiene dati personali.',
    },
    invalid: {
        demo_opening: 'Apertura del soggiorno …',
        hotel_fallback: 'Il vostro hotel',
        reception: 'Reception',
        eyebrow: 'Vi serve un nuovo link?',
        title: 'Nessun problema — lo risolviamo rapidamente',
        text: 'Per la vostra sicurezza, questo link non è più valido. La vostra prenotazione non è stata annullata e nessun dato è andato perso.',
        help_title: 'Come procedere',
        step_contact_title: 'Contattate la reception',
        step_contact_text: "Chiamate l'hotel o inviate un breve messaggio.",
        step_identify_title: 'Indicate a quale soggiorno si riferisce',
        step_identify_text: "Sono sufficienti il nome dell'ospite e la data di arrivo prevista.",
        step_open_title: 'Aprite il nuovo link',
        step_open_text: "L'hotel ve lo invierà via e-mail o messaggio.",
        retry: 'Riprova',
        security: 'Limitiamo la durata dei link per proteggere i dati del vostro soggiorno.',
    },
    /*
     * Hiša — vsebina sobnih televizorjev na telefonu (docs/DISPLAY.md §9).
     *
     * Svoj imenski prostor, ker je to stavba in ne bivanje: isto besedilo vidi vsak gost
     * v hiši, ne glede na svojo rezervacijo. Izrazje je namenoma isto kot na zaslonih
     * (`house.*`, `local.kind_*` v pms-display), da hiša na steni in na telefonu ne
     * govori dveh jezikov.
     */
    house: {
        sign_up: 'Iscrivici',
        signed_up: 'Iscritti',
        signup_count: '{count} iscritti',
        guest_deal: "Per gli ospiti dell'hotel: {deal}",
        voucher_title: 'Il vostro buono sconto',
        voucher_open: 'Apri il buono',
        voucher_note: "Mostrate il QR o aprite il link presso il partner — la pagina conferma in tempo reale che siete ospiti dell'hotel.",
        locked_eye: 'Si sblocca al check-in',
        locked_text: 'I contenuti della struttura — Wi-Fi, lettera di benvenuto, programma e dintorni — si sbloccano sul vostro telefono al check-in in hotel. Ci vediamo alla reception!',
        title: 'La struttura',
        loading: 'Caricamento …',
        failed: 'Al momento non è possibile mostrare i contenuti della struttura. Riprovate tra qualche istante.',
        section_house: 'BENVENUTI',
        section_letter: 'LETTERA DI BENVENUTO',
        section_today: 'OGGI NELLA STRUTTURA',
        section_weather: 'METEO',
        section_services: 'SERVIZI E LISTINO',
        section_events: 'EVENTI NEI DINTORNI',
        section_places: 'LUOGHI NEI DINTORNI',
        wifi: 'Rete wireless',
        network: 'Rete',
        password: 'Password',
        wifi_open: 'La rete è aperta, non serve la password.',
        hours: 'Orari',
        phone_keys: 'Tasti del telefono',
        room_phone: 'Dal telefono in camera.',
        emergency: 'Chiamata di emergenza',
        per_day: '/ giorno',
        per_item: '/ una tantum',
        to_services: 'Prenotate un servizio',
        open_in_maps: 'Apri in Google Maps',
        kind_sight: 'Attrazione',
        kind_restaurant: 'Dove mangiare',
        kind_activity: 'Attività',
        kind_shop: 'Negozi',
        kind_other: 'Altro nei dintorni',
    },
    /* Napoved je Open-Meteo; `weather` je beseda za nebo, ki jo prevede zaslon. */
    weather: {
        today: 'oggi',
        rain_chance: '{percent} %',
        clear: 'sereno',
        partly_cloudy: 'parzialmente nuvoloso',
        overcast: 'coperto',
        fog: 'nebbia',
        drizzle: 'pioviggine',
        rain: 'pioggia',
        rain_showers: 'rovesci',
        snow: 'neve',
        snow_showers: 'rovesci di neve',
        thunderstorm: 'temporale',
    },
    /*
     * Milo, the house's assistant in the guest's own hands.
     *
     * Short sentences on purpose: this is read on a telephone, standing up, usually with
     * one hand. `executed` says "handed over" and never "done" — every one of the four
     * actions is a REQUEST the hotel then acts on, and a portal that said "done" would
     * be promising on the hotel's behalf.
     *
     * `result.*` is what a confirmed proposal DID, keyed by the outcome code the service
     * sends. The Slovenian 1/2/3-4/5+ forms are chosen in `libs/chatResult.ts` and not by
     * vue-i18n, for the reason written there; the other languages carry the same four
     * keys so that the two locale files never disagree about which keys exist.
     */
    milo: {
        title: 'Milo',
        greeting: 'Salve, sono Milo.',
        intro: "Chiedetemi dell'hotel e del vostro soggiorno — rispondo nella vostra lingua.",
        placeholder: 'Scrivete la vostra domanda …',
        send: 'Invia',
        thinking: 'Milo sta pensando …',
        still_working: 'Sto ancora cercando — può volerci un minuto.',
        disclaimer: "Milo è l'assistente dell'hotel. Non accetta pagamenti e non emette fatture; per tutto il resto c'è la reception.",
        open: 'Apri Milo',
        close: 'Chiudi',
        chip_wifi: 'Wi-Fi',
        chip_wifi_text: 'Qual è la password del Wi-Fi?',
        chip_breakfast: 'Colazione',
        chip_breakfast_text: 'Fino a che ora è servita la colazione?',
        chip_late_checkout: 'Check-out posticipato',
        chip_late_checkout_text: "Posso restare in camera un po' più a lungo?",
        chip_today: 'Cosa succede oggi',
        chip_today_text: 'Cosa succede oggi nei dintorni?',
        confirm: 'Conferma',
        decline: 'No, non ora',
        executed: 'Inviato',
        declined: 'Non inviato.',
        failed: 'Non ha funzionato. Riprovate o chiamate la reception.',
        expired: 'Questa proposta è scaduta. Chiedete di nuovo.',
        already_decided: 'Su questa proposta è già stata presa una decisione.',
        card_closed: 'Questa proposta non può più essere confermata.',
        budget_spent: 'Per oggi le domande sono terminate. Riprovate domani o chiamate la reception.',
        throttled: 'Un momento — riprovate tra qualche secondo.',
        too_long: 'Milo ha impiegato troppo tempo per questa domanda. Chiedete qualcosa di più preciso o chiamate la reception.',
        interrupted: 'Milo è stato interrotto mentre rispondeva. Chiedete di nuovo, per favore.',
        unavailable: 'Milo non è disponibile al momento. La reception è a vostra disposizione.',
        result: {
            late_checkout_requested:    'La vostra richiesta di check-out posticipato è alla reception.',
            guest_service_booked_one:   'Prenotato per {count} giorno.',
            guest_service_booked_two:   'Prenotato per {count} giorni.',
            guest_service_booked_few:   'Prenotato per {count} giorni.',
            guest_service_booked_other: 'Prenotato per {count} giorni.',
            room_request_raised:        'La vostra richiesta è al servizio ai piani.',
            reception_message_sent:     'Il vostro messaggio è alla reception.',
            room_service_ordered_one:   'La cucina ha il suo ordine: {count} voce, {detail}.',
            room_service_ordered_two:   'La cucina ha il suo ordine: {count} voci, {detail}.',
            room_service_ordered_few:   'La cucina ha il suo ordine: {count} voci, {detail}.',
            room_service_ordered_other: 'La cucina ha il suo ordine: {count} voci, {detail}.',
            lost_item_reported:         'La sua segnalazione è registrata con il numero {detail}; la reception la avviserà.',
            transfer_requested:         'La sua richiesta di trasferimento ({detail}) è alla reception.',
        },
    },
}
